export const BASE_URL_SANCTUM = '/sanctum/csrf-cookie/';
